import React from 'react';
import { Button } from 'antd';

export function GenericButton({ icon, children, label, ...props }) {
  return (
    <Button {...props}>
      {icon}
      {label}
      {children}
    </Button>
  );
}
